import './App.css';
import SiteContainer from './components/SiteContainer';

function App() {
  return (
    <div className="App">
      <SiteContainer />
    </div>
  );
}

export default App;
